import Div from "@jumbo/shared/Div/Div";
import { Button, MenuItem, Select, Switch, Typography } from "@mui/material";
import ListOptions from "app/components/Dropdown/ListOptions";
import FormTextField from "app/components/InputField/FormTextField";
import {
  codeList,
  genderList,
  outerDiv,
} from "app/utils/constants/dropdowns.js";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ErrorMessage, Form, Formik } from "formik";
import * as yup from "yup";
import React, { useEffect, useState } from "react";
import { dateFun, formattedDate } from "app/utils/constants/functions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { updateUserDetailsAdmin } from "app/services/apis/updateUserDetailsAdmin";
import Swal from "sweetalert2";
import { addUser } from "app/services/apis/addUser";
import { getRoles } from "app/services/apis/getRoles";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { loadUser } from "app/redux/actions/userAction";

export default function EditUserProfile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSubmitting, setSubmitting] = useState(false);
  const { user } = useSelector((state) => state.userReducer);
  const profileData = {
    first_name: user?.first_name ? user?.first_name : "",
    last_name: user?.last_name ? user?.last_name : "",
    country_code: user?.country_code ? user?.country_code : "+91",
    phone: user?.phone ? user?.phone : null,
    gender: user?.gender ? user?.gender : "Select",
    date_of_birth: user?.date_of_birth ? user?.date_of_birth : formattedDate,
  };

  const validationSchema = yup.object({
    first_name: yup
      .string("Enter First Name")
      .required("First Name is required")
      .matches(
        /^[A-Za-z]+$/,
        "First Name must contain only alphabetic characters"
      ),
    last_name: yup
      .string("Enter Last Name")
      .required("Last Name is required")
      .matches(
        /^[A-Za-z]+$/,
        "Last Name must contain only alphabetic characters"
      ),

    phone: yup
      .number()
      .typeError("Phone number must be a number")
      .required("Phone Number is Required"),
    gender: yup
      .string()
      .required("Gender is required")
      .test(
        "gender-not-select",
        "Please select a valid Gender",
        (value) => value !== "Select"
      ),
    date_of_birth: yup
      .date()
      .test("not-current-date", "Enter Valid Date of Birth", function (value) {
        if (!value) {
          // Handle case where value is not provided
          return false;
        }

        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Set time to midnight

        return value < currentDate; // Change this to <= to allow the current date
      })
      .required("Date Of Birth is required"),
  });

  const onUserSave = async (values) => {
    setSubmitting(true);
    try {
      const config = {
        withCredentials: true,
        headers: {
          withCredentials: true,
        },
      };
      const data = await axios.post(
        `${process.env.REACT_APP_URL}/api/profile/update-user-profile?id=${user?.id}`,
        { ...values, date_of_birth: dateFun(values?.date_of_birth) },
        config
      );
      if (data?.status == 200) {
        Swal.fire({ icon: "success", title: "Profile Updated" });
        navigate("/dashboard/user");
        dispatch(loadUser());
      }
    } catch (error) {
      Swal.fire({ icon: "error", title: "Profile Not Updated" });
    }
    setSubmitting(false);
  };

  return (
    <Div sx={{ mt: -4 }}>
      <Typography variant="h1">Edit User Profile</Typography>
      <Div>
        <Formik
          validateOnChange={true}
          initialValues={profileData}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={onUserSave}
        >
          {({ setFieldValue, values }) => (
            <Form noValidate autoComplete="off">
              <Div sx={{ mt: 4 }}>
                <Div
                  sx={{
                    display: "flex",
                    width: "100%",
                    flexWrap: "wrap",
                    columnGap: 4,
                  }}
                >
                  <FormTextField name="first_name" label="First Name" />
                  <FormTextField name="last_name" label="Last Name" />
                  <ListOptions
                    name="gender"
                    label="Gender"
                    options={genderList}
                  />
                  <Div sx={{ width: "45%" }}>
                    <Typography variant="h5">Phone No*</Typography>
                    <Div sx={{ display: "flex", mt: -1 }}>
                      <ListOptions
                        options={codeList}
                        name={"country_code"}
                        sx={{ width: "80px" }}
                      />
                      <FormTextField name="phone" sx={{ width: "100%" }} />
                    </Div>
                  </Div>

                  <Div sx={outerDiv}>
                    <Typography variant="h5">Date of Birth</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{
                          "&.MuiTextField-root": {
                            height: "39px",
                            flexDirection: "unset",
                          },
                        }}
                        maxDate={dayjs()}
                        format="DD/MM/YYYY"
                        defaultValue={dayjs(values.date_of_birth)}
                        onChange={(date) => {
                          setFieldValue("date_of_birth", date);
                        }}
                      />
                      <Div sx={{ height: "30px" }}>
                        <ErrorMessage
                          name="date_of_birth"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </Div>
                    </LocalizationProvider>
                  </Div>
                </Div>

                <Div
                  sx={{
                    width: "93.5%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 3,
                    mt: 3,
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure you want to cancel?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          navigate("/dashboard/user");
                        }
                      });
                    }}
                  >
                    Cancel
                  </Button>
                  <LoadingButton
                    variant="contained"
                    type="submit"
                    sx={{ width: "100px" }}
                    loading={isSubmitting}
                  >
                    Save
                  </LoadingButton>
                </Div>
              </Div>
            </Form>
          )}
        </Formik>
      </Div>
    </Div>
  );
}
